// PhotoTaskInput.js - AI-Assisted Task Breakdown
import React, { useState } from 'react';

const PhotoTaskInput = () => {
    const [image, setImage] = useState(null);

    const handleFile = e => {
        const file = e.target.files[0];
        if (file) setImage(URL.createObjectURL(file));
    };

    return (
        <div className="p-4 bg-green-50 rounded shadow-sm my-2 mx-4">
            <h2 className="font-semibold text-green-700">Snap & Go 📸</h2>
            {image ? (
                <img src={image} alt="Task Input" className="w-full rounded mt-2" />
            ) : (
                <input type="file" accept="image/*" onChange={handleFile} />
            )}
            <p className="mt-2 text-sm text-gray-600">Upload a photo and NeuroNest suggests your first steps.</p>
        </div>
    );
};

export default PhotoTaskInput;